// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationInstallmentsPi3Path = 'M56.25 2.5H52.5v45.915l28.938 16.708 10.826 6.25 1.875-3.248A43.75 43.75 0 0056.25 2.5zM60 28.907v-6.11a23.75 23.75 0 0114.509 8.265 5.002 5.002 0 001.741 9.688 4.977 4.977 0 002.87-.905 23.747 23.747 0 01-.685 14.883l-6.41-3.7a5 5 0 10-8.504-4.91L60 44.085v-5.492a5 5 0 100-9.685zM87.5 46.25c0 4.228-.858 8.4-2.507 12.264l4.357 2.516A36.25 36.25 0 0060 10.194v5.032A31.25 31.25 0 0187.5 46.25zM40 17.695A36.25 36.25 0 0010.65 68.53L40 51.585v-33.89zM21.875 15.86A43.75 43.75 0 0143.75 10h3.75v41.585l36.014 20.792-1.875 3.248a43.75 43.75 0 01-73.763 3.167l-.14.08-1.875-3.247-.09-.157-1.784-3.09.139-.08A43.75 43.75 0 0121.875 15.86zM14.4 75.025a36.25 36.25 0 0058.7 0L43.75 58.08 14.4 75.025z';
var IllustrationInstallmentsPi3 = baseIllustration('IllustrationInstallmentsPi3', {
  getPath: () => IllustrationInstallmentsPi3Path
});

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationInstallmentsPi3;
//# sourceMappingURL=index.js.map